import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DsInlineAlertComponent } from '@customdesignsystem';

/**
 * InlineAlert del paso 0 (borde #545B6A + InfoFill) — Figma V1.
 * Soporta título opcional + contenido proyectado.
 */
@Component({
  selector: 'app-pi-info-alert',
  standalone: true,
  imports: [CommonModule, DsInlineAlertComponent],
  template: `
    <ds-inline-alert
      class="pi-info-alert"
      type="neutral"
      emphasis="outline"
      size="s"
      icon="InfoFill"
      [title]="title">
      <ng-content></ng-content>
    </ds-inline-alert>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      /* InlineAlert — Figma */
      :host ::ng-deep .ds-inline-alert {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 8px;
        gap: 8px;
        width: 100%;
        background: #ffffff;
        border: 1px solid #545b6a;
        border-radius: 8px;
      }

      /* Icon 24×24, glyph 16×16, #545B6A */
      :host ::ng-deep .ds-inline-alert__icon {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex: 0 0 auto;
        width: 24px;
        height: 24px;
        color: #545b6a;
        --_icon-size: 16px;
      }

      /* Content */
      :host ::ng-deep .ds-inline-alert__layout {
        min-height: auto;
        gap: 0;
      }

      :host ::ng-deep .ds-inline-alert__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 6px;
        width: 100%;
        min-width: 0;
        overflow-wrap: normal;
        word-break: normal;
      }

      /* Body/S/SemiBold — title */
      :host ::ng-deep .ds-inline-alert__title {
        font-family: var(--ds-foundation-font-family-primary, 'Sura Sans', sans-serif);
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        color: #2f343f;
      }

      /* Body/S/Regular — description (Figma) */
      :host ::ng-deep .ds-inline-alert__description {
        display: block !important;
        flex-direction: unset;
        width: 100%;
        font-family: var(--ds-foundation-font-family-primary, 'Sura Sans', sans-serif);
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #545b6a;
      }

      :host ::ng-deep .ds-inline-alert__description > * {
        margin: 0;
      }

      :host ::ng-deep .ds-inline-alert__description a {
        display: inline;
        white-space: nowrap;
        color: #0b4bd3 !important;
      }

      :host ::ng-deep a,
      :host ::ng-deep button.pi-info-alert__link {
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
        color: #0b4bd3 !important;
        font: inherit;
        font-weight: 600;
        text-decoration: underline;
        text-underline-offset: 0.16em;
        cursor: pointer;
      }
    `,
  ],
})
export class PiInfoAlertComponent {
  @Input() title = '';
  @Input() ariaLabel = 'Información';
}
